/* Posternia Pro — product.js
   Strona produktu i kreator: wybór wariantu, galeria, powiększenie, obracany plakat 3D, zakładki,
   przyklejony przycisk, „Zobacz u siebie” i blokada zakupu przed startem dropu.
   Przy każdej zmianie wariantu wysyła zdarzenie `variant:change` na elemencie [data-product]. */
(function () {
  'use strict';
  if (window.__pstrnProduct) return;
  window.__pstrnProduct = true;

  var theme = window.theme;
  var U = theme.utils;
  var $ = U.$, $$ = U.$$, clamp = U.clamp, debounce = U.debounce, formatMoney = U.formatMoney, escapeHtml = U.escapeHtml;
  var reduceMotion = theme.reduceMotion;

  var SIZES = { A0: [84, 118.9], A1: [59.4, 84], A2: [42, 59.4], A3: [29.7, 42], A4: [21, 29.7], A5: [14.8, 21], B0: [100, 140], B1: [70, 100], B2: [50, 70], B3: [35, 50] };
  function parseSize(value) {
    if (!value) return null;
    var s = String(value).toUpperCase().replace(/,/g, '.');
    var m = s.match(/(?:^|[^A-Z0-9])([AB][0-5])(?![0-9])/);
    if (m && SIZES[m[1]]) return SIZES[m[1]].slice();
    m = s.match(/(\d+(?:\.\d+)?)\s*[X×]\s*(\d+(?:\.\d+)?)/);
    return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
  }
  // Ramy są tylko czarne i białe; kolory ustawia się w Ustawieniach motywu → Zdjęcia plakatów
  function finishOf(value) { return /biał|bial|white/i.test(value || '') ? 'white' : 'black'; }
  function finishColor(finish) {
    var c = theme.frameColors || {};
    if (finish === 'none') return null;
    return finish === 'white' ? (c.white || '#f2f1ed') : (c.black || '#111111');
  }
  function frameColor(value) { return finishColor(finishOf(value)); }
  theme.poster = { parseSize: parseSize, finishOf: finishOf, finishColor: finishColor, frameColor: frameColor };

  function moveIndicator(container, active, el) {
    if (!container || !active || !el) return;
    var c = container.getBoundingClientRect(), a = active.getBoundingClientRect();
    el.style.setProperty('--x', (a.left - c.left + container.scrollLeft) + 'px');
    el.style.setProperty('--w', a.width + 'px');
  }

  function fmtCountdown(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (d > 0 ? d + ' ' + theme.strings.days + ' ' : '') + p(h) + ':' + p(m) + ':' + p(sec);
  }

  function initProduct(root) {
    $$('[data-product]', root).forEach(function (product) {
      if (product.dataset.productReady) return;
      product.dataset.productReady = '1';

      var gallery = initGallery(product);
      var viewer = initViewer3d(product);
      initViewTabs(product, viewer);
      initZoom(product);
      initQuantity(product);
      initTabs(product);
      initStickyBuy(product);
      var room = initRoom(product);
      initPersonal(product);

      var form = $('[data-product-form]', product);
      var idInput = form && $('[data-variant-id]', form);
      var addBtn = form && $('[data-add-button]', form);
      var addLabel = form && $('[data-add-label]', form);
      var priceWrap = $('[data-product-price] [data-price]', product);
      var stickyPrice = $('[data-sticky-price]', product);
      var stickyVariant = $('[data-sticky-variant]', product);
      var stickyAdd = $('[data-sticky-add]', product);
      var stickyLabel = $('[data-sticky-label]', product);
      var shortLabel = stickyLabel ? stickyLabel.textContent : '';
      var picker = $('[data-variant-picker]', product);
      var sizeIndex = parseInt(product.getAttribute('data-size-index'), 10);

      // Blokada przed startem dropu
      var dropStart = form ? Date.parse(form.getAttribute('data-drop-start') || '') : NaN;
      var locked = !isNaN(dropStart) && dropStart > Date.now();
      var current = null;

      var setButtons = function (v) {
        var label;
        if (locked) label = theme.strings.dropIn + ' ' + fmtCountdown(dropStart - Date.now());
        else label = !v ? theme.strings.unavailable : (v.available ? theme.strings.addToCart : theme.strings.soldOut);
        var disabled = locked || !v || !v.available;
        if (addBtn) { addBtn.disabled = disabled; addLabel.textContent = label; }
        if (stickyAdd) stickyAdd.disabled = disabled;
        if (stickyLabel) stickyLabel.textContent = disabled ? (locked ? theme.strings.dropLocked : label) : shortLabel;
      };
      if (locked) {
        var lockTimer = setInterval(function () {
          if (dropStart <= Date.now()) { locked = false; clearInterval(lockTimer); }
          setButtons(current);
        }, 1000);
      }

      // Wspólny stan dla podglądu, obrotu 3D, „Zobacz u siebie” i kreatora
      var emit = function (v, opts) {
        var sizeValue = sizeIndex > -1 ? opts[sizeIndex] : null;
        var finishFs = picker && $('[data-finish-option]', picker);
        var checked = finishFs && ($('[data-finish]:checked', finishFs) || $('[data-finish]', finishFs));
        var finish = checked ? checked.getAttribute('data-finish') : (product.getAttribute('data-default-finish') || 'black');
        var label = checked ? checked.getAttribute('data-label') : '';
        var sizeShort = sizeValue ? String(sizeValue).split(' (')[0] : '';
        var detail = {
          variant: v, options: opts, size: sizeValue, sizeShort: sizeShort, finish: finish, finishLabel: label,
          frame: finish !== 'none' ? (label || finish) : null, frameColor: finishColor(finish), cm: parseSize(sizeValue),
          label: [sizeShort, label].filter(Boolean).join(' · ')
        };
        product._state = detail;
        $$('[data-poster][data-live]', product).forEach(function (p) { p.setAttribute('data-finish', finish); });
        if (viewer) viewer.set(detail);
        if (room) room.sync(detail);
        product.dispatchEvent(new CustomEvent('variant:change', { detail: detail, bubbles: true }));
      };

      if (!picker) {
        current = { available: addBtn ? !addBtn.disabled : true };
        setButtons(current);
        emit(null, []);
        return;
      }

      var variants = JSON.parse($('[data-variants-json]', picker).textContent);
      var nOpts = variants[0] ? variants[0].options.length : 0;
      var finishFs = $('[data-finish-option]', picker);
      var framePos = parseInt(picker.getAttribute('data-frame-position'), 10);
      var colorPos = parseInt(picker.getAttribute('data-color-position'), 10);
      var optionFs = $$('fieldset[data-option-position]', picker).filter(function (fs) { return fs !== finishFs; });
      var finishInputs = finishFs ? $$('[data-finish]', finishFs) : [];
      // Kolor ramy zapamiętany na wypadek „Bez ramki” (wariant bez ramki też ma kolor w danych sklepu)
      var lastColor = null;
      if (colorPos > -1) {
        var startColor = finishInputs.filter(function (i) { return i.checked && i.getAttribute('data-color-value'); })[0];
        var startVariant = variants.find(function (v) { return String(v.id) === (idInput && idInput.value); });
        lastColor = startColor ? startColor.getAttribute('data-color-value') : (startVariant ? startVariant.options[colorPos] : null);
      }

      var isNone = function () {
        var f = finishFs && $('[data-finish]:checked', finishFs);
        return !!f && f.getAttribute('data-finish') === 'none';
      };
      var withFinish = function (opts, input) {
        var o = opts.slice();
        o[framePos] = input.getAttribute('data-frame-value');
        if (colorPos > -1) o[colorPos] = input.getAttribute('data-color-value') || null;
        return o;
      };
      var selected = function () {
        var opts = [];
        for (var k = 0; k < nOpts; k++) opts.push(null);
        optionFs.forEach(function (fs) {
          var c = $('input.opt__input:checked', fs);
          opts[parseInt(fs.getAttribute('data-option-position'), 10)] = c ? c.value : null;
        });
        if (finishFs && finishInputs.length) {
          var f = $('[data-finish]:checked', finishFs) || finishInputs[0];
          opts = withFinish(opts, f);
          if (colorPos > -1 && !opts[colorPos]) opts[colorPos] = lastColor;
        }
        return opts;
      };
      // null w opcjach = dowolna wartość
      var matches = function (v, opts) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); };
      var findVariant = function (opts) {
        var v = variants.find(function (x) { return matches(x, opts); });
        if (!v && colorPos > -1 && isNone()) {
          var loose = opts.slice(); loose[colorPos] = null;
          v = variants.find(function (x) { return x.available && matches(x, loose); }) || variants.find(function (x) { return matches(x, loose); });
        }
        return v;
      };
      var minPrice = function (opts) {
        var list = variants.filter(function (v) { return matches(v, opts); });
        return list.length ? Math.min.apply(null, list.map(function (v) { return v.price; })) : null;
      };
      // Cena dla innego formatu lub wykończenia (np. przyciski w „Zobacz u siebie”)
      product._price = function (q) {
        var o = selected();
        if (q.size != null && sizeIndex > -1) o[sizeIndex] = q.size;
        var fin = q.finish ? finishInputs.filter(function (i) { return i.getAttribute('data-finish') === q.finish; })[0]
          : finishInputs.filter(function (i) { return i.checked; })[0];
        if (fin) o = withFinish(o, fin);
        return minPrice(o);
      };
      var markAvailability = function (opts) {
        var base = opts.slice();
        if (colorPos > -1 && isNone()) base[colorPos] = null;
        optionFs.forEach(function (fs) {
          var pos = parseInt(fs.getAttribute('data-option-position'), 10);
          $$('input.opt__input', fs).forEach(function (input) {
            var o = base.slice(); o[pos] = input.value;
            var ok = variants.some(function (v) { return v.available && matches(v, o); });
            var label = input.nextElementSibling;
            if (label) label.classList.toggle('is-unavailable', !ok);
            var priceEl = label && $('[data-size-price]', label);
            if (priceEl) { var p = minPrice(o); if (p != null) priceEl.textContent = formatMoney(p); }
          });
        });
        finishInputs.forEach(function (input) {
          var o = withFinish(opts, input);
          var ok = variants.some(function (v) { return v.available && matches(v, o); });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !ok);
          var priceEl = label && $('[data-finish-price]', label);
          if (priceEl) { var p = minPrice(o); priceEl.textContent = p != null ? formatMoney(p) : ''; }
        });
      };
      var updatePrice = function (v) {
        if (!priceWrap || !v) return;
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        var html = '';
        if (onSale) html += '<span class="visually-hidden">' + escapeHtml(theme.strings.regularPrice) + '</span><s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="visually-hidden">' + escapeHtml(theme.strings.salePrice) + '</span>';
        html += '<span class="price__current">' + formatMoney(v.price) + '</span>';
        priceWrap.innerHTML = html;
        priceWrap.classList.toggle('price--sold-out', !v.available);
        if (!reduceMotion.matches && priceWrap.animate) priceWrap.animate([{ opacity: .3, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.16,1,.3,1)' });
      };

      var update = function (fromUser) {
        var opts = selected();
        var v = findVariant(opts);
        current = v;
        markAvailability(opts);
        optionFs.forEach(function (fs) {
          var out = $('[data-option-selected]', fs), c = $('input.opt__input:checked', fs);
          if (out) out.textContent = c ? (c.getAttribute('data-short') || c.value) : '';
        });
        if (finishFs) {
          var out = $('[data-option-selected]', finishFs), f = $('[data-finish]:checked', finishFs);
          if (out) out.textContent = f ? f.getAttribute('data-label') : '';
        }
        setButtons(v);
        if (v) {
          if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
          updatePrice(v);
          if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
          // Szybki podgląd nie zmienia adresu strony, na której otwarto okno
          if (fromUser && !product.hasAttribute('data-quick')) {
            var url = new URL(location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState(history.state, '', url.toString());
            if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
          }
        }
        emit(v, v ? v.options : opts);
        if (stickyVariant && product._state) stickyVariant.textContent = product._state.label;
      };

      picker.addEventListener('change', function (e) {
        if (e.target.matches('[data-finish]') && e.target.getAttribute('data-color-value')) lastColor = e.target.getAttribute('data-color-value');
        update(true);
      });
      // „Zobacz u siebie” i obrót 3D mogą zmienić format lub wykończenie z poziomu swoich przycisków
      product.addEventListener('variant:pick', function (e) {
        var d = e.detail || {};
        if (d.size != null && sizeIndex > -1) {
          var fs = optionFs.filter(function (x) { return parseInt(x.getAttribute('data-option-position'), 10) === sizeIndex; })[0];
          var input = fs && $$('input.opt__input', fs).filter(function (i) { return i.value === d.size; })[0];
          if (input) input.checked = true;
        }
        if (d.finish && finishFs) {
          var fin = finishInputs.filter(function (i) { return i.getAttribute('data-finish') === d.finish; })[0];
          if (fin) { fin.checked = true; if (fin.getAttribute('data-color-value')) lastColor = fin.getAttribute('data-color-value'); }
        }
        update(true);
      });
      update(false);
    });
  }

  function initQuantity(root) {
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      $$('[data-qty-step]', q).forEach(function (b) {
        b.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10)); });
      });
    });
  }

  function initViewTabs(product, viewer) {
    var tabs = $('[data-view-tabs]', product);
    if (!tabs) return;
    var btns = $$('[data-view]', tabs);
    var thumb = $('.seg__thumb', tabs);
    var select = function (btn, focus) {
      btns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = $('[data-view-panel="' + b.getAttribute('data-view') + '"]', product);
        if (panel) {
          panel.hidden = !on;
          if (on) { panel.classList.remove('is-entering'); void panel.offsetWidth; panel.classList.add('is-entering'); }
        }
      });
      moveIndicator(tabs, btn, thumb);
      if (focus) btn.focus();
      if (viewer && btn.getAttribute('data-view') === '3d') viewer.intro();
    };
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        select(btns[(i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length], true);
      });
    });
    var sync = function () { moveIndicator(tabs, $('.is-active', tabs), thumb); };
    requestAnimationFrame(sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    window.addEventListener('resize', debounce(sync, 150));
  }

  function initGallery(product) {
    var track = $('[data-gallery-track]', product);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', product);
    var dots = $$('.gallery__dots span', product);
    var prev = $('[data-gallery-prev]', product), next = $('[data-gallery-next]', product);
    var index = 0;
    var setActive = function (i) {
      index = i;
      slides.forEach(function (s, j) { s.classList.toggle('is-current', j === i); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    var goTo = function (i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      setActive(i);
    };
    track.addEventListener('scroll', debounce(function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) setActive(i);
    }, 60), { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, index - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, index + 1)); });
    setActive(0);
    return {
      goToMedia: function (id) {
        var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(id); });
        if (i > -1) goTo(i);
      }
    };
  }

  /* ---------- Obrót 3D ----------
     Przód: zdjęcie produktu w wybranym wykończeniu (ten sam plakat co w galerii).
     Tył: z ramą płyta HDF z zawieszką i zaczepami, bez ramki tył papieru z lekko przebijającym nadrukiem.
     Przeciąganie z bezwładnością (poziome przeciąganie obraca, pionowe przewija stronę), przyciski Przód/Tył, strzałki. */
  function initViewer3d(product) {
    var root = $('[data-viewer3d]', product);
    if (!root) return null;
    var stage = $('[data-v3d-stage]', root), obj = $('[data-v3d-obj]', root);
    var poster = $('.v3d__front [data-poster]', root), labelEl = $('[data-v3d-label]', root);
    var sideBtns = $$('[data-v3d-side]', root);
    var REST_X = -7, REST_Y = -26;
    var ry = REST_Y, rx = REST_X, vy = 0, vx = 0, target = null, dragging = false, moved = false;
    var lastX = 0, lastY = 0, raf = null, t = 0, interacted = false, visible = false;
    var finish = obj.getAttribute('data-finish') || 'black';
    var num = function (name) { return parseFloat(poster ? poster.style.getPropertyValue(name) : '') || 0; };

    // Wymiary w px: obiekt bez ramki jest mniejszy o grubość ramy (jak w rzeczywistości)
    var layout = function () {
      var sw = stage.clientWidth, sh = stage.clientHeight;
      if (!sw || !sh) return;
      var ar = num('--ar') || .707;
      var W = Math.min(sw * (ar > 1 ? .72 : .6), sh * .72 * ar), H = W / ar;
      var fx = num('--fx') / 100, fy = num('--fy') / 100;
      var none = finish === 'none';
      var s = obj.style;
      s.setProperty('--w', (none ? W * (1 - 2 * fx) : W).toFixed(1) + 'px');
      s.setProperty('--h', (none ? H * (1 - 2 * fy) : H).toFixed(1) + 'px');
      s.setProperty('--d', (none ? 1.2 : Math.max(9, W * .05)).toFixed(1) + 'px');
      s.setProperty('--pw', W.toFixed(1) + 'px');
      s.setProperty('--ph', H.toFixed(1) + 'px');
      s.setProperty('--px', (none ? -W * fx : 0).toFixed(1) + 'px');
      s.setProperty('--py', (none ? -H * fy : 0).toFixed(1) + 'px');
      s.setProperty('--fbx', (W * fx).toFixed(1) + 'px');
      s.setProperty('--fby', (H * fy).toFixed(1) + 'px');
    };

    var apply = function () {
      obj.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      var n = ((ry % 360) + 360) % 360, rad = n * Math.PI / 180;
      obj.style.setProperty('--glare', (50 + Math.sin(rad) * 80).toFixed(1) + '%');
      root.style.setProperty('--turn', Math.abs(Math.cos(rad)).toFixed(3));
      var back = n > 90 && n < 270;
      root.classList.toggle('is-back', back);
      sideBtns.forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-v3d-side') === 'back') === back ? 'true' : 'false'); });
    };
    var loop = function () {
      raf = null;
      if (!visible) return;
      if (!dragging) {
        if (target !== null) {
          var diff = target - ry;
          ry += diff * .1; rx += (REST_X - rx) * .1;
          if (Math.abs(diff) < .05) { ry = target; target = null; }
        } else if (Math.abs(vy) > .01 || Math.abs(vx) > .01) {
          ry += vy; rx = clamp(rx + vx, -26, 26); vy *= .95; vx *= .88;
        } else if (!interacted && !reduceMotion.matches) {
          t += .008; ry = REST_Y + Math.sin(t) * 24; rx = REST_X + Math.sin(t * .8) * 4;
        } else {
          rx += (REST_X - rx) * .04;
        }
      }
      apply();
      raf = requestAnimationFrame(loop);
    };
    var start = function () { if (!raf && visible) raf = requestAnimationFrame(loop); };

    stage.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      dragging = true; moved = false; target = null; vx = vy = 0;
      lastX = e.clientX; lastY = e.clientY;
      stage.setPointerCapture(e.pointerId);
      stage.classList.add('is-dragging');
      start();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      if (!moved && Math.abs(dx) + Math.abs(dy) > 3) { moved = true; interacted = true; }
      vy = dx * .5; vx = -dy * .25;
      ry += vy; rx = clamp(rx + vx, -26, 26);
    });
    var end = function () { dragging = false; stage.classList.remove('is-dragging'); };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('lostpointercapture', end);

    var turnTo = function (side) {
      interacted = true; vx = vy = 0;
      var aim = side === 'back' ? 180 + 16 : -16;
      target = Math.round((ry - aim) / 360) * 360 + aim;
      start();
    };
    sideBtns.forEach(function (b) { b.addEventListener('click', function () { turnTo(b.getAttribute('data-v3d-side')); }); });
    stage.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      interacted = true; vx = vy = 0;
      target = (target !== null ? target : ry) + (e.key === 'ArrowLeft' ? -30 : 30);
      start();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting && !root.closest('[hidden]');
        if (visible) { layout(); start(); }
      }).observe(root);
    } else { visible = true; }
    if ('ResizeObserver' in window) new ResizeObserver(debounce(layout, 60)).observe(stage);
    layout();
    apply();

    return {
      set: function (d) {
        finish = d.finish || 'black';
        obj.setAttribute('data-finish', finish);
        if (d.frameColor) obj.style.setProperty('--frame', d.frameColor);
        if (labelEl) labelEl.textContent = d.label || '';
        layout();
      },
      intro: function () {
        visible = true; layout(); start();
        if (!reduceMotion.matches && !interacted) { vy = 7; interacted = true; }
      }
    };
  }

  function initTabs(product) {
    $$('[data-tabs]', product).forEach(function (tabs) {
      var btns = $$('[role="tab"]', tabs), ink = $('.tabs__ink', tabs), list = $('.tabs__list', tabs), current = 0;
      var select = function (i, focus) {
        if (i === current) { if (focus) btns[i].focus(); return; }
        var dir = i > current ? 1 : -1;
        var oldPanel = document.getElementById(btns[current].getAttribute('aria-controls'));
        var newPanel = document.getElementById(btns[i].getAttribute('aria-controls'));
        btns.forEach(function (b, j) { var on = j === i; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; });
        current = i;
        moveIndicator(list, btns[i], ink);
        if (focus) btns[i].focus();
        if (reduceMotion.matches || !oldPanel.animate) { oldPanel.hidden = true; newPanel.hidden = false; return; }
        oldPanel.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-20 * dir) + 'px)' }], { duration: 160, easing: 'ease-in' }).finished.then(function () {
          oldPanel.hidden = true; newPanel.hidden = false;
          newPanel.animate([{ opacity: 0, transform: 'translateX(' + (20 * dir) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 440, easing: 'cubic-bezier(.16,1,.3,1)' });
          if (window.ScrollTrigger) ScrollTrigger.refresh();
        });
      };
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % btns.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + btns.length) % btns.length, true); }
        });
      });
      var sync = function () { moveIndicator(list, btns[current], ink); };
      requestAnimationFrame(sync);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
      window.addEventListener('resize', debounce(sync, 150));
    });
  }

  function initStickyBuy(product) {
    var bar = $('[data-sticky-buy]', product), main = $('[data-add-button]', product);
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var footer = $('.section-footer');
    var mainVisible = true, footerVisible = false;
    var sync = function () {
      var show = !mainVisible && !footerVisible && main.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      if (show) { bar.removeAttribute('inert'); bar.setAttribute('aria-hidden', 'false'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    };
    new IntersectionObserver(function (e) { mainVisible = e[0].isIntersecting; sync(); }).observe(main);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; sync(); }).observe(footer);
  }

  function initZoom(product) {
    var dialog = $('[data-zoom-dialog]', product), buttons = $$('[data-zoom-index]', product);
    if (!dialog || !buttons.length) return;
    var stage = $('[data-zoom-stage]', dialog), img = $('[data-zoom-img]', dialog);
    var current = 0, scale = 1, tx = 0, ty = 0, SCALE = 2.6, dragging = false, moved = false, sx = 0, sy = 0, stx = 0, sty = 0;
    var apply = function () { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; stage.classList.toggle('is-zoomed', scale > 1); };
    var clampPos = function () { var w = stage.clientWidth, h = stage.clientHeight; tx = Math.min(0, Math.max(w - w * scale, tx)); ty = Math.min(0, Math.max(h - h * scale, ty)); };
    var reset = function () { scale = 1; tx = 0; ty = 0; apply(); };
    var show = function (i) { current = (i + buttons.length) % buttons.length; img.src = buttons[current].getAttribute('data-zoom-src'); img.alt = buttons[current].getAttribute('data-zoom-alt') || ''; reset(); };
    var zoomAt = function (x, y) { scale = SCALE; tx = x - x * scale; ty = y - y * scale; clampPos(); apply(); };
    buttons.forEach(function (b) { b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-zoom-index'), 10)); theme.openDialog(dialog, b); }); });
    $('[data-zoom-prev]', dialog).addEventListener('click', function () { show(current - 1); });
    $('[data-zoom-next]', dialog).addEventListener('click', function () { show(current + 1); });
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false; sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
      if (scale > 1) stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
      if (scale > 1 && moved) { stage.classList.add('is-dragging'); tx = stx + dx; ty = sty + dy; clampPos(); apply(); }
    });
    stage.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false; stage.classList.remove('is-dragging');
      if (moved) return;
      if (scale > 1) reset(); else { var r = stage.getBoundingClientRect(); zoomAt(e.clientX - r.left, e.clientY - r.top); }
    });
    stage.addEventListener('pointercancel', function () { dragging = false; stage.classList.remove('is-dragging'); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === '+' || e.key === '=') zoomAt(stage.clientWidth / 2, stage.clientHeight / 2);
      if (e.key === '-') reset();
    });
    dialog.addEventListener('close', reset);
  }

  /* ---------- Personalizacja: pola tekstowe i zdjęcie ----------
     Pola są poza formularzem (atrybut form=), więc trafiają do koszyka jako właściwości pozycji.
     Przed dodaniem do koszyka sprawdzamy wymagane pola i pokazujemy błąd pod polem. */
  function initPersonal(product) {
    var fields = $$('[data-pfield]', product);
    var form = $('[data-product-form]', product);
    if (!fields.length || !form) return;
    var S = theme.strings;

    fields.forEach(function (f) {
      var input = $('input, textarea, select', f), count = $('[data-count]', f);
      if (count && input) {
        var max = count.getAttribute('data-max');
        var upd = function () { count.textContent = input.value.length + ' / ' + max; };
        input.addEventListener('input', upd); upd();
      }
      if (input) input.addEventListener('input', function () { setError(f, ''); });
    });

    var setError = function (f, msg) {
      var err = $('.pfield__err', f), input = $('input, textarea, select', f);
      if (!err) return;
      err.textContent = msg; err.hidden = !msg;
      f.classList.toggle('has-error', !!msg);
      if (input) { if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
    };

    /* Zdjęcie: podgląd, wymiary i ocena ostrości dla wybranego formatu */
    $$('[data-pdrop]', product).forEach(function (drop) {
      var f = drop.closest('[data-pfield]'), input = $('input[type="file"]', drop);
      var emptyEl = $('.pdrop__empty', drop), filled = $('.pdrop__filled', drop);
      var imgEl = $('[data-pdrop-img]', drop), nameEl = $('[data-pdrop-name]', drop), metaEl = $('[data-pdrop-meta]', drop), qEl = $('[data-pdrop-q]', drop);
      var maxMb = parseFloat(drop.getAttribute('data-max-mb')) || 20, url = null, dims = null;
      var quality = function () {
        if (!dims || !qEl) return;
        var cm = product._state && product._state.cm;
        if (!cm) { qEl.textContent = ''; return; }
        var longPx = Math.max(dims[0], dims[1]), longIn = Math.max(cm[0], cm[1]) / 2.54;
        var dpi = Math.round(longPx / longIn);
        var minDpi = (theme.print && theme.print.minDpi) || 90;
        var level = dpi >= 150 ? 'good' : dpi >= minDpi ? 'ok' : 'low';
        qEl.textContent = S['photo_' + level].replace('%SIZE%', product._state.sizeShort || '');
        qEl.setAttribute('data-level', level);
      };
      var show = function (file) {
        setError(f, '');
        if (!file) { filled.hidden = true; emptyEl.hidden = false; dims = null; return; }
        if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) { input.value = ''; setError(f, S.photoType); return; }
        if (file.size > maxMb * 1024 * 1024) { input.value = ''; setError(f, S.photoSize.replace('%SIZE%', maxMb)); return; }
        if (url) URL.revokeObjectURL(url);
        url = URL.createObjectURL(file);
        nameEl.textContent = file.name;
        var weight = file.size < 1048576 ? Math.max(1, Math.round(file.size / 1024)) + ' KB' : (file.size / 1048576).toFixed(1).replace('.', ',') + ' MB';
        metaEl.textContent = weight;
        qEl.textContent = '';
        imgEl.onload = function () {
          dims = [imgEl.naturalWidth, imgEl.naturalHeight];
          metaEl.textContent = dims[0] + ' × ' + dims[1] + ' px · ' + weight;
          quality();
        };
        imgEl.onerror = function () { dims = null; };
        imgEl.src = url;
        emptyEl.hidden = true; filled.hidden = false;
      };
      input.addEventListener('change', function () { show(input.files && input.files[0]); });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) {
        e.preventDefault();
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        try { var dt = new DataTransfer(); dt.items.add(files[0]); input.files = dt.files; } catch (err) { return; }
        show(files[0]);
      });
      product.addEventListener('variant:change', quality);
    });

    /* Sprawdzenie przed dodaniem do koszyka (działa przed obsługą koszyka w core.js) */
    form.addEventListener('submit', function (e) {
      var first = null;
      fields.forEach(function (f) {
        var input = $('input, textarea, select', f);
        if (!input) return;
        var empty = input.type === 'file' ? !(input.files && input.files.length) : !input.value.trim();
        var msg = input.required && empty ? (input.type === 'file' ? S.photoRequired : S.fieldRequired) : '';
        setError(f, msg);
        if (msg && !first) first = input;
      });
      if (!first) return;
      e.preventDefault();
      e.stopPropagation();
      var target = first.type === 'file' ? first.closest('[data-pdrop]') : first;
      target.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      (first.type === 'file' ? first : first).focus({ preventScroll: true });
    });
  }

  /* ---------- „Zobacz u siebie” ----------
     Wnętrza to rysunki w centymetrach (viewBox 420 × 270, podłoga na wysokości 228), więc plakat ma prawdziwą skalę.
     Na zdjęciu ściany skalę daje kalibracja: dwa znaczniki na przedmiocie o znanej wysokości (drzwi, kartka A4).
     Pozycja plakatu to środek w poziomie i dolna krawędź, żeby większy format rósł w górę, a nie wchodził na meble.
     Zdjęcie nie opuszcza przeglądarki. */
  function initRoom(product) {
    var dialog = document.getElementById(product.getAttribute('data-room-id') || '');
    if (!dialog) return null;
    var stage = $('[data-room-stage]', dialog), wrap = $('[data-room-poster]', dialog);
    var poster = $('[data-poster]', wrap), img = poster && $('img', poster);
    var scenes = $$('[data-room-scene]', dialog), photo = $('[data-room-photo]', dialog);
    var tag = $('[data-room-tag]', dialog), hint = $('[data-room-hint]', dialog);
    var calLayer = $('[data-room-cal]', dialog), calBox = $('[data-room-calbox]', dialog);
    var tools = $('[data-room-phototools]', dialog), empty = $('[data-room-empty]', dialog);
    var wallsBox = $('[data-room-walls]', dialog), photoBg = $('[data-room-photo-bg]', dialog);
    var scaleInput = $('[data-room-scale]', dialog), scaleNote = $('[data-room-scale-note]', dialog);
    var priceEl = $('[data-room-price]', dialog), labelEl = $('[data-room-label]', dialog), addBtn = $('[data-room-add]', dialog);
    var handles = $$('[data-cal-handle]', dialog), calLine = $('[data-cal-line]', dialog), calTag = $('[data-cal-tag]', dialog);
    var VB = { w: 420, h: 270 };
    var TOPS = { salon: 140, sypialnia: 112, biuro: 112, przedpokoj: 146 };
    var GAP = 24;
    var st = { scene: 'salon', finish: 'black', cm: [42, 59.4], size: null, sizeShort: '', label: '', variant: null };
    var pos = {}, ph = null, refCm = 200, calibrating = false, geo = null;

    var num = function (name) { return parseFloat(poster ? poster.style.getPropertyValue(name) : '') || 0; };
    var isPhoto = function () { return st.scene === 'photo'; };
    var mapping = function () {
      var W = stage.clientWidth, H = stage.clientHeight, s;
      // Zdjęcie ściany widać w całości (bez przycinania); skala = zmierzona albo przybliżona × suwak
      if (isPhoto() && ph) { s = Math.min(W / ph.w, H / ph.h); var k = ph.k * ph.f; return { s: s, ox: (W - ph.w * s) / 2, oy: (H - ph.h * s) / 2, perCm: k * s, unit: k }; }
      s = Math.max(W / VB.w, H / VB.h);
      return { s: s, ox: (W - VB.w * s) / 2, oy: H - VB.h * s, perCm: s, unit: 1 };
    };
    // Wymiar elementu w cm; wewnątrz ramy (albo po przycięciu bez ramki) widać dokładnie format plakatu
    var posterCm = function () {
      var c = st.cm || [42, 59.4];
      var w = Math.min(c[0], c[1]), h = Math.max(c[0], c[1]);
      if ((num('--ar') || .7) > 1) { var t = w; w = h; h = t; }
      return { w: w / (1 - 2 * num('--fx') / 100), h: h / (1 - 2 * num('--fy') / 100), pw: w, ph: h };
    };
    var bounds = function (d, m) {
      if (isPhoto()) return { x0: 0, x1: ph.w, b0: d.h * m.unit, b1: ph.h };
      return { x0: 20, x1: VB.w - 20, b0: d.h + 6, b1: 219 };
    };
    var current = function (d, m) {
      var k = isPhoto() ? 'photo' : st.scene;
      if (!pos[k]) pos[k] = isPhoto() ? { x: ph.w / 2, b: ph.h * .48 + d.h * m.unit / 2 } : { x: VB.w / 2, b: TOPS[st.scene] - GAP };
      return pos[k];
    };
    var fmtCm = function (v) { return String(Math.round(v * 10) / 10).replace('.', ','); };

    var layout = function () {
      var ready = !isPhoto() || (ph && !calibrating);
      wrap.hidden = !ready; tag.hidden = !ready;
      if (!ready || !stage.clientWidth) return;
      var m = mapping(), d = posterCm(), p = current(d, m), bd = bounds(d, m);
      p.x = clamp(p.x, bd.x0, bd.x1); p.b = clamp(p.b, bd.b0, bd.b1);
      var w = d.w * m.perCm, h = d.h * m.perCm;
      var x = m.ox + p.x * m.s - w / 2, y = m.oy + p.b * m.s - h;
      geo = { x: x, y: y, w: w, h: h };
      wrap.style.width = w.toFixed(1) + 'px';
      wrap.style.height = h.toFixed(1) + 'px';
      wrap.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      tag.textContent = (st.sizeShort ? st.sizeShort + ' · ' : '') + fmtCm(d.pw) + ' × ' + fmtCm(d.ph) + ' cm';
      tag.style.transform = 'translate(' + (x + w / 2).toFixed(1) + 'px,' + (y + h + 10).toFixed(1) + 'px) translateX(-50%)';
    };

    /* Przeciąganie plakatu i strzałki (2 cm, z Shift 10 cm) */
    var drag = null;
    wrap.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      var m = mapping(), p = current(posterCm(), m);
      drag = { x: e.clientX, y: e.clientY, px: p.x, pb: p.b };
      wrap.setPointerCapture(e.pointerId);
      wrap.classList.add('is-dragging');
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var m = mapping(), p = current(posterCm(), m);
      p.x = drag.px + (e.clientX - drag.x) / m.s;
      p.b = drag.pb + (e.clientY - drag.y) / m.s;
      layout();
    });
    var endDrag = function () { drag = null; wrap.classList.remove('is-dragging'); };
    wrap.addEventListener('pointerup', endDrag);
    wrap.addEventListener('pointercancel', endDrag);
    wrap.addEventListener('keydown', function (e) {
      var m = mapping(), p = current(posterCm(), m), step = (e.shiftKey ? 10 : 2) * m.unit;
      if (e.key === 'ArrowLeft') p.x -= step; else if (e.key === 'ArrowRight') p.x += step;
      else if (e.key === 'ArrowUp') p.b -= step; else if (e.key === 'ArrowDown') p.b += step;
      else return;
      e.preventDefault();
      layout();
    });

    /* Wnętrza, kolor ściany, zdjęcie */
    var setHint = function (k) { if (hint) hint.textContent = hint.getAttribute('data-hint-' + k) || hint.textContent; };
    var pick = function (scene) {
      st.scene = scene;
      $$('[data-room-pick]', dialog).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-room-pick') === scene ? 'true' : 'false'); });
      // SVG nie ma właściwości hidden, więc przełączamy atrybut
      scenes.forEach(function (s) { s.toggleAttribute('hidden', s.getAttribute('data-room-scene') !== scene); });
      var photoMode = isPhoto();
      photo.hidden = !photoMode || !ph;
      if (photoBg) photoBg.hidden = photo.hidden;
      empty.hidden = !photoMode || !!ph;
      wallsBox.hidden = photoMode;
      tools.hidden = !photoMode || !ph || calibrating;
      calBox.hidden = !photoMode || !calibrating;
      calLayer.hidden = !photoMode || !calibrating;
      stage.classList.toggle('is-photo', photoMode);
      setHint(photoMode ? (calibrating ? 'cal' : 'photo') : 'room');
      layout();
    };
    $$('[data-room-pick]', dialog).forEach(function (b) { b.addEventListener('click', function () { pick(b.getAttribute('data-room-pick')); }); });
    $$('[data-wall]', dialog).forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-wall');
        $$('rect[data-wall]', dialog).forEach(function (r) { r.setAttribute('fill', c); });
        $$('button[data-wall]', dialog).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });

    var photoUrl = null;
    $$('[data-room-file]', dialog).forEach(function (input) {
      input.addEventListener('change', function () {
        var f = input.files && input.files[0];
        input.value = '';
        if (!f || !/^image\//.test(f.type)) return;
        if (photoUrl) URL.revokeObjectURL(photoUrl);
        photoUrl = URL.createObjectURL(f);
        photo.onload = function () {
          // Przybliżona skala: zdjęcie pionowe z 2–3 m obejmuje ok. 240 cm wysokości ściany, poziome ok. 160 cm
          var w = photo.naturalWidth, h = photo.naturalHeight;
          ph = { w: w, h: h, k: h / (h >= w ? 240 : 160), f: 1, a: null, b: null, measured: false };
          delete pos.photo;
          calibrating = false;
          setScaleUi();
          pick('photo');
        };
        photo.src = photoUrl;
        if (photoBg) photoBg.src = photoUrl;
      });
    });

    /* Skala zdjęcia: suwak i dwa palce na zdjęciu */
    var setScaleUi = function () {
      if (!ph) return;
      if (scaleInput) { scaleInput.value = Math.round(ph.f * 100); scaleInput.setAttribute('aria-valuetext', Math.round(ph.f * 100) + '%'); }
      if (scaleNote) scaleNote.textContent = scaleNote.getAttribute(ph.measured ? 'data-measured' : 'data-estimate');
    };
    if (scaleInput) scaleInput.addEventListener('input', function () {
      if (!ph) return;
      ph.f = clamp(parseFloat(scaleInput.value) / 100, .4, 2.5);
      scaleInput.setAttribute('aria-valuetext', Math.round(ph.f * 100) + '%');
      layout();
    });
    var touches = {}, pinch = null;
    stage.addEventListener('pointerdown', function (e) {
      if (!isPhoto() || !ph || calibrating || e.pointerType !== 'touch') return;
      touches[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(touches);
      if (ids.length === 2) {
        var a = touches[ids[0]], b = touches[ids[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, f: ph.f };
        endDrag();
      }
    }, true);
    stage.addEventListener('pointermove', function (e) {
      if (!touches[e.pointerId]) return;
      touches[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(touches);
      if (!pinch || ids.length < 2) return;
      var a = touches[ids[0]], b = touches[ids[1]];
      ph.f = clamp(pinch.f * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d, .4, 2.5);
      setScaleUi();
      layout();
    }, true);
    var lift = function (e) { delete touches[e.pointerId]; if (Object.keys(touches).length < 2) pinch = null; };
    stage.addEventListener('pointerup', lift, true);
    stage.addEventListener('pointercancel', lift, true);

    /* Kalibracja: znaczniki trzymane we współrzędnych zdjęcia, więc przetrwają zmianę rozmiaru okna */
    var toStage = function (pt) { var m = mapping(); return { x: m.ox + pt.x * m.s, y: m.oy + pt.y * m.s }; };
    var toPhoto = function (x, y) { var m = mapping(); return { x: clamp((x - m.ox) / m.s, 0, ph.w), y: clamp((y - m.oy) / m.s, 0, ph.h) }; };
    var drawCal = function () {
      if (!calibrating || !ph) return;
      var A = toStage(ph.a), B = toStage(ph.b);
      handles[0].style.transform = 'translate(' + A.x + 'px,' + A.y + 'px)';
      handles[1].style.transform = 'translate(' + B.x + 'px,' + B.y + 'px)';
      calLine.setAttribute('x1', A.x); calLine.setAttribute('y1', A.y);
      calLine.setAttribute('x2', B.x); calLine.setAttribute('y2', B.y);
      calTag.textContent = fmtCm(refCm) + ' cm';
      calTag.style.transform = 'translate(' + ((A.x + B.x) / 2 + 16) + 'px,' + ((A.y + B.y) / 2) + 'px) translateY(-50%)';
    };
    var startCal = function () {
      calibrating = true;
      if (!ph.a) { ph.a = { x: ph.w * .5, y: ph.h * .3 }; ph.b = { x: ph.w * .5, y: ph.h * .7 }; }
      pick('photo');
      drawCal();
      handles[0].focus({ preventScroll: true });
    };
    var endCal = function (measured) {
      // „Pomiń” zostawia dotychczasową skalę; pomiar ustawia dokładną i zeruje suwak
      if (measured) {
        var dist = Math.hypot(ph.a.x - ph.b.x, ph.a.y - ph.b.y);
        if (dist > 4 && refCm > 0) { ph.k = dist / refCm; ph.f = 1; ph.measured = true; }
      }
      setScaleUi();
      calibrating = false;
      delete pos.photo;
      pick('photo');
    };
    handles.forEach(function (hd) {
      var which = hd.getAttribute('data-cal-handle');
      hd.addEventListener('pointerdown', function (e) { hd.setPointerCapture(e.pointerId); hd.classList.add('is-dragging'); });
      hd.addEventListener('pointermove', function (e) {
        if (!hd.hasPointerCapture(e.pointerId)) return;
        var r = stage.getBoundingClientRect();
        ph[which] = toPhoto(e.clientX - r.left, e.clientY - r.top);
        drawCal();
      });
      var up = function () { hd.classList.remove('is-dragging'); };
      hd.addEventListener('pointerup', up);
      hd.addEventListener('pointercancel', up);
      hd.addEventListener('keydown', function (e) {
        var d = { ArrowUp: [0, -1], ArrowDown: [0, 1], ArrowLeft: [-1, 0], ArrowRight: [1, 0] }[e.key];
        if (!d) return;
        e.preventDefault();
        var step = (e.shiftKey ? 20 : 4) / mapping().s;
        ph[which] = { x: clamp(ph[which].x + d[0] * step, 0, ph.w), y: clamp(ph[which].y + d[1] * step, 0, ph.h) };
        drawCal();
      });
    });
    var refBtns = $$('[data-cal-ref]', dialog), custom = $('[data-cal-custom]', dialog);
    refBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        refCm = parseFloat(b.getAttribute('data-cal-ref'));
        refBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (custom) custom.value = '';
        drawCal();
      });
    });
    if (custom) custom.addEventListener('input', function () {
      var v = parseFloat(custom.value);
      if (v > 0) { refCm = v; refBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); drawCal(); }
    });
    $('[data-cal-done]', dialog).addEventListener('click', function () { endCal(true); });
    $('[data-cal-skip]', dialog).addEventListener('click', function () { endCal(false); });
    $('[data-cal-start]', dialog).addEventListener('click', function () { if (ph) startCal(); });

    /* Format i wykończenie z poziomu okna: zmieniają wybór na stronie produktu */
    $$('[data-room-size]', dialog).forEach(function (b) {
      b.addEventListener('click', function () { product.dispatchEvent(new CustomEvent('variant:pick', { detail: { size: b.getAttribute('data-room-size') } })); });
    });
    $$('[data-room-finish]', dialog).forEach(function (b) {
      b.addEventListener('click', function () { product.dispatchEvent(new CustomEvent('variant:pick', { detail: { finish: b.getAttribute('data-room-finish') } })); });
    });
    var finishInputs = $$('[data-finish-option] [data-finish]', product);
    $$('[data-room-finish]', dialog).forEach(function (b) {
      var f = b.getAttribute('data-room-finish');
      if (finishInputs.length && !finishInputs.some(function (i) { return i.getAttribute('data-finish') === f; })) b.hidden = true;
    });

    if (addBtn) addBtn.addEventListener('click', function () {
      var form = $('[data-product-form]', product);
      if (!form) return;
      theme.closeDialog(dialog);
      if (form.requestSubmit) form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });

    /* Zapis obrazu: scena (albo zdjęcie) + plakat w wybranym wykończeniu */
    var loadImg = function (src, cors) {
      return new Promise(function (resolve, reject) {
        var im = new Image();
        if (cors) im.crossOrigin = 'anonymous';
        im.onload = function () { resolve(im); };
        im.onerror = reject;
        im.src = src;
      });
    };
    var drawPoster = function (ctx, src) {
      if (!geo) return;
      var iw = num('--iw') || 100, ih = num('--ih') || 100;
      var mx = (1 - 100 / iw) / 2, my = (1 - 100 / ih) / 2, fx = num('--fx') / 100, fy = num('--fy') / 100;
      var nw = src.naturalWidth, nh = src.naturalHeight;
      var sx = nw * mx, sy = nh * my, sw = nw * (1 - 2 * mx), sh = nh * (1 - 2 * my);
      var x = geo.x, y = geo.y, w = geo.w, h = geo.h, fw = w * fx, fh = h * fy;
      var none = st.finish === 'none';
      ctx.save();
      ctx.shadowColor = 'rgba(0,0,0,.32)'; ctx.shadowBlur = none ? 10 : 22; ctx.shadowOffsetX = none ? 1 : 3; ctx.shadowOffsetY = none ? 4 : 9;
      if (none) {
        ctx.fillStyle = '#fff'; ctx.fillRect(x + fw, y + fh, w - 2 * fw, h - 2 * fh);
        ctx.shadowColor = 'transparent';
        ctx.drawImage(src, sx + sw * fx, sy + sh * fy, sw * (1 - 2 * fx), sh * (1 - 2 * fy), x + fw, y + fh, w - 2 * fw, h - 2 * fh);
      } else {
        var col = finishColor(st.finish);
        ctx.fillStyle = col; ctx.fillRect(x, y, w, h);
        ctx.shadowColor = 'transparent';
        ctx.drawImage(src, sx, sy, sw, sh, x, y, w, h);
        ctx.fillStyle = col;
        ctx.fillRect(x, y, w, fh); ctx.fillRect(x, y + h - fh, w, fh);
        ctx.fillRect(x, y, fw, h); ctx.fillRect(x + w - fw, y, fw, h);
      }
      ctx.restore();
    };
    var saveBtn = $('[data-room-save]', dialog);
    if (saveBtn) saveBtn.addEventListener('click', function () {
      var W = stage.clientWidth, H = stage.clientHeight, k = 2;
      var c = document.createElement('canvas');
      c.width = W * k; c.height = H * k;
      var ctx = c.getContext('2d');
      ctx.scale(k, k);
      var background;
      if (isPhoto() && ph) {
        var m = mapping();
        ctx.fillStyle = '#1d1d1f';
        ctx.fillRect(0, 0, W, H);
        ctx.drawImage(photo, m.ox, m.oy, ph.w * m.s, ph.h * m.s);
        background = Promise.resolve();
      } else {
        var svg = scenes.filter(function (s) { return !s.hasAttribute('hidden'); })[0].cloneNode(true);
        svg.removeAttribute('hidden');
        svg.setAttribute('width', W); svg.setAttribute('height', H);
        background = loadImg('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg)))
          .then(function (im) { ctx.drawImage(im, 0, 0, W, H); });
      }
      background
        .then(function () { return loadImg(product._roomImage || (img && (img.currentSrc || img.src)), !product._roomImage); })
        .then(function (src) {
          drawPoster(ctx, src);
          var a = document.createElement('a');
          a.download = 'posternia-na-scianie.png';
          a.href = c.toDataURL('image/png');
          a.click();
        })
        .catch(function () { U.toast(theme.strings.cartError); });
    });

    /* Otwieranie */
    $$('[data-open-room]', product).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (product._roomImage && img) { img.removeAttribute('srcset'); img.src = product._roomImage; }
        if (product._state) sync(product._state);
        theme.openDialog(dialog, btn);
        requestAnimationFrame(function () { layout(); drawCal(); });
      });
    });
    if ('ResizeObserver' in window) new ResizeObserver(debounce(function () { layout(); drawCal(); }, 50)).observe(stage);
    if (img) img.addEventListener('load', layout);

    var sync = function (d) {
      st.cm = d.cm || st.cm;
      st.finish = d.finish || st.finish;
      st.size = d.size; st.sizeShort = d.sizeShort || ''; st.variant = d.variant;
      $$('[data-room-size]', dialog).forEach(function (b) {
        var v = b.getAttribute('data-room-size');
        b.setAttribute('aria-pressed', v === d.size ? 'true' : 'false');
        var pr = $('[data-room-size-price]', b), price = product._price ? product._price({ size: v }) : null;
        if (pr) pr.textContent = price != null ? formatMoney(price) : '';
      });
      $$('[data-room-finish]', dialog).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-room-finish') === st.finish ? 'true' : 'false'); });
      // Niedostępne warianty: ten sam stan co na stronie produktu (przekreślone karty)
      var picked = function (sel) { var i = $(sel, product); return !!(i && i.nextElementSibling && i.nextElementSibling.classList.contains('is-unavailable')); };
      $$('[data-room-size]', dialog).forEach(function (b) {
        var v = b.getAttribute('data-room-size');
        var input = $$('[data-size-option] input.opt__input', product).filter(function (i) { return i.value === v; })[0];
        b.classList.toggle('is-unavailable', !!(input && input.nextElementSibling.classList.contains('is-unavailable')));
      });
      $$('[data-room-finish]', dialog).forEach(function (b) {
        b.classList.toggle('is-unavailable', picked('[data-finish-option] [data-finish="' + b.getAttribute('data-room-finish') + '"]'));
      });
      if (labelEl) labelEl.textContent = d.label || '';
      if (priceEl) priceEl.textContent = d.variant ? formatMoney(d.variant.price) : '';
      var mainAdd = $('[data-add-button]', product);
      if (addBtn) addBtn.disabled = !!(mainAdd && mainAdd.disabled);
      layout();
    };
    return { sync: sync };
  }

  theme.initProduct = initProduct;
  initProduct(document);
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
})();
